/*
 * @Descripttion: 
 * @Author: zhongbin.chen
 * @Date: 2021-09-07 16:16:40
 * @LastEditors: zhongbin.chen
 * @LastEditTime: 2021-12-16 14:50:23
 */
import { RootObject } from '@/model/rootObject'
import { UserInfoModel, Users } from '@/model/userModel'
import https from '@/utils/https'
import { LoginModel } from '@/views/user-manager/login/model/loginModel'
import { RequestParams, ContentType, Method } from 'axios-mapper'

export const loginRequest = (userInfo: RequestParams) => {
  return https(false).request<RootObject<LoginModel>>('sysUser/auth', Method.POST, userInfo, ContentType.json)
}

export const userInfoRequest = () => {
  return https().request<RootObject<UserInfoModel>>('sysUser/user', Method.GET, undefined, ContentType.form)
}

export const getUsers = (user: any) => {
  return https().request<RootObject<Users>>('user/getUsers', Method.GET, user, ContentType.form)
}

// 修改密码
export const updatePasssword = (params: any) => {
  return https().request('user', Method.PUT, params, ContentType.json)
}

// 获取所有企业号
export const Companies = () => {
  return https().request('companies', Method.GET, {}, ContentType.form)
}

// 获取机器人列表
export const getRobotList = (params: any) => {
  return https().request('v1/robot-status/as', Method.GET, params, ContentType.form)
}
// 语言设置
export const setLang = (params: any) => {
  return https().request('language/set', Method.PUT, params, ContentType.json)
}
// 机器人权限编辑
export const robotPermission = (params: any) => {
  return https().request('permission/edit', Method.PUT, params, ContentType.json)
}
export const langInfo = (params: any) => {
  return https().request('language/get', Method.GET, params, ContentType.form)
}
export const robotPermissionInfo = (params: any) => {
  return https().request('permission/edit', Method.GET, params, ContentType.form)
}
